hrd.utils.export.AbstractExporter = hrd.Class.extend({
	init: function(tableManager, options) {
		var defaults = {
			impl: 'hrd.utils.export.AbstractExporter'
		};
		this._super($.extend({}, defaults, options));
		this.tableManager = tableManager;
		this.tableInstance = tableManager.tableInstance;
		this.reference = this.tableManager.settings.reference;
		this.toolbox = new hrd.Toolbox();
	},
	export: function() {
		let settings = this.tableInstance.fnSettings();
		let columns = settings.aoColumns;
		let prefix = this.getDataTypePrefix();
		let headerData = this.exportHeader(columns);
		let rowsData = this.exportRows(columns);
		let contentData = `${headerData}${rowsData}`;
		this.downloadFileFn(prefix, contentData);
	},
	exportHeader: function(columns) {
		this.__abstractMethod__(arguments.callee);
	},
	getColumnTitle: function(column) {
		let titleFn = this.toolbox.get('export.titleFn', column);
		if (typeof titleFn === 'function') {
			return titleFn.call(this.reference, column);
		} else {
			return this.toolbox.get('export.title', column, column.sTitle);
		}
	},
	exportRows: function(columns) {
		this.__abstractMethod__(arguments.callee);
	},
	exportRow: function(row, columns) {
		this.__abstractMethod__(arguments.callee);
	},
	exportableColumn: function(column) {
		let skipColumn = false;
		let skipColumnFn = this.toolbox.get('export.skipFn', column);
		if (typeof skipColumnFn === 'function') {
			skipColumn = skipColumnFn.call(this.reference, column);
		} else {
			skipColumn = this.toolbox.get('export.skip', column, false);
		}
		let excludeTypes = ['icon', 'action', 'scollbar-ph'];
		return !skipColumn && !excludeTypes.includes(column.type);
	},
	getDataTypePrefix: function() {
		this.__abstractMethod__(arguments.callee);
	},
	getExtension: function() {
		this.__abstractMethod__(arguments.callee);
	},
	downloadFileFn: function(prefix, data) {
		let fileName = this.getFileName();
		let encodedContent = encodeURIComponent(data);
		let encodedUri = `${prefix}${encodedContent}`;
		var link = document.createElement("a");
		link.setAttribute("href", encodedUri);
		link.setAttribute("download", fileName);
		document.body.appendChild(link);
		link.click();
		link.remove();
	},
	getFileName: function() {
		let namePart = this.settings.fileName || 'Export';
		let dataPart = moment().format('YYYY_MM_DD_HH_mm');
		let extPart = this.getExtension();
		return `${namePart}_${dataPart}.${extPart}`;
	},
	extractValue: function(rowData, columnInfo) {
		let value = this.toolbox.get(columnInfo.mData, rowData);
		if (this.toolbox.isEmpty(value)) {
			let type = this.toolbox.get('export.type', columnInfo, 'string');
			switch (type.toLowerCase()) {
				case 'amount':
					// use 0,00 as default amount
					value = '0,00';
					break;
				default:
					// nothing to do
					break;
			}
		}
		return value;
	}
});